module.exports = __webpack_public_path__ + "static/img/map2.85b1dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdwan/map2.png
// module id = Uic5
// module chunks = 0